'use strict';

var _extends = require('@babel/runtime/helpers/extends');

var _objectWithoutProperties = require('@babel/runtime/helpers/objectWithoutProperties');

var React = require('react');

var injectSheet = require('react-jss');

var THEME = require('pobble-components/dist/theme');

var classNames = require('classnames');

var PropTypes = require('prop-types');

function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}

var _extends__default =
/*#__PURE__*/
_interopDefaultLegacy(_extends);

var _objectWithoutProperties__default =
/*#__PURE__*/
_interopDefaultLegacy(_objectWithoutProperties);

var React__default =
/*#__PURE__*/
_interopDefaultLegacy(React);

var injectSheet__default =
/*#__PURE__*/
_interopDefaultLegacy(injectSheet);

var THEME__default =
/*#__PURE__*/
_interopDefaultLegacy(THEME);

var classNames__default =
/*#__PURE__*/
_interopDefaultLegacy(classNames);

var PropTypes__default =
/*#__PURE__*/
_interopDefaultLegacy(PropTypes);

var COLORS = THEME__default["default"].COLORS;
var styles = {
  spinner: {
    fontSize: '40px',
    width: '1em',
    height: '1em',
    position: 'relative',
    animation: 'spCircRot .6s infinite linear',
    padding: '2px',
    color: COLORS.BLUE.NORMAL,
    '& > div': {
      position: 'relative',
      width: '100%',
      height: '100%',
      '&:after': {
        content: '""',
        border: '2px solid currentColor',
        position: 'absolute',
        left: '-2px',
        top: '-2px',
        width: '100%',
        height: '100%',
        borderRadius: '50%',
        opacity: '.3',
        zIndex: '100'
      },
      '&:before': {
        content: '""',
        position: 'absolute',
        left: '-2px',
        top: '-2px',
        width: '100%',
        height: '100%',
        border: '2px solid transparent',
        borderTop: '2px solid currentColor',
        borderRadius: '50%',
        zIndex: '110'
      }
    }
  },
  '@keyframes spCircRot': {
    from: {
      transform: 'rotate(0deg)'
    },
    to: {
      transform: 'rotate(359deg)'
    }
  }
};
var _excluded = ["classes", "className"];

var Spinner = function Spinner(_ref) {
  var classes = _ref.classes,
      className = _ref.className,
      props = _objectWithoutProperties__default["default"](_ref, _excluded);

  return (
    /*#__PURE__*/
    React__default["default"].createElement("div", _extends__default["default"]({
      className: classNames__default["default"](classes.spinner, className)
    }, props),
    /*#__PURE__*/
    React__default["default"].createElement("div", null))
  );
};

Spinner.propTypes = {
  /** Additional className to restyle component */
  className: PropTypes__default["default"].string,

  /** Rewrite style of the component */
  style: PropTypes__default["default"].object
};
var index = injectSheet__default["default"](styles)(Spinner);
module.exports = index;